
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_1hpp3_n1i8p_193",
  "arrow-outer": "awsui_arrow-outer_1hpp3_n1i8p_197",
  "arrow-inner": "awsui_arrow-inner_1hpp3_n1i8p_197",
  "arrow-position-right-top": "awsui_arrow-position-right-top_1hpp3_n1i8p_239",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_1hpp3_n1i8p_239",
  "arrow-position-left-top": "awsui_arrow-position-left-top_1hpp3_n1i8p_242",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_1hpp3_n1i8p_242",
  "arrow-position-top-center": "awsui_arrow-position-top-center_1hpp3_n1i8p_245",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_1hpp3_n1i8p_245",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_1hpp3_n1i8p_248",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_1hpp3_n1i8p_248",
  "annotation": "awsui_annotation_1hpp3_n1i8p_252",
  "next-button": "awsui_next-button_1hpp3_n1i8p_253",
  "previous-button": "awsui_previous-button_1hpp3_n1i8p_254",
  "finish-button": "awsui_finish-button_1hpp3_n1i8p_255",
  "header": "awsui_header_1hpp3_n1i8p_256",
  "step-counter-content": "awsui_step-counter-content_1hpp3_n1i8p_257",
  "content": "awsui_content_1hpp3_n1i8p_258",
  "description": "awsui_description_1hpp3_n1i8p_262",
  "actionBar": "awsui_actionBar_1hpp3_n1i8p_267",
  "stepCounter": "awsui_stepCounter_1hpp3_n1i8p_274",
  "divider": "awsui_divider_1hpp3_n1i8p_278",
  "hotspot": "awsui_hotspot_1hpp3_n1i8p_282",
  "icon": "awsui_icon_1hpp3_n1i8p_352"
};
  